export const AGREE_JOIN_GROUP = 1 // 同意司仪团队邀请
export const REFUSE_JOIN_GROUP = 0 // 拒绝司仪团队邀请

export const AGREE_APPLY_GROUP = 1 // 同意司仪成员加入团队
export const REFUSE_APPLY_GROUP = 0 // 拒绝司仪成员加入团队

// 1资深 2专家 3总监 4首席 5创始人
export const POSITION_ZISHEN = 1
export const POSITION_ZHUANJIA = 2
export const POSITION_ZONGJIAN = 3
export const POSITION_SHOUXI = 4
export const POSITION_CHUANGSHI = 5

export const POSITION_MAP = {
  [POSITION_ZISHEN]: '资深',
  [POSITION_ZHUANJIA]: '专家',
  [POSITION_ZONGJIAN]: '总监',
  [POSITION_SHOUXI]: '首席',
  [POSITION_CHUANGSHI]: '创始人'
}

// 团队邀请成员加入 0未处理 1同意 2拒绝 3已失效
export const SIYI_INVITE_NOT_HANDLE = 0
export const SIYI_INVITE_AGREE = 1
export const SIYI_INVITE_REFUSE = 2
export const SIYI_INVITE_INVALID = 3

// 成员申请加入团队 0未处理 1同意 2拒绝 3已失效
export const SIYI_APPLY_NOT_HANDLE = 0
export const SIYI_APPLY_AGREE = 1
export const SIYI_APPLY_REFUSE = 2
export const SIYI_APPLY_INVALID = 3

// 司仪个人移动端主页
export const SIYI_MEMBER_WAP_HOME = '/p/wedding/Public/wap/m/emcee/#/index'
// 司仪团队移动端主页
export const SIYI_TEAM_WAP_HOME = '/p/wedding/Public/wap/m/emcee/#/team-index'
